// extracted by mini-css-extract-plugin
export var inlineLink = "_61-0";
export var inlineLinkButton = "_61-1";